import { render, staticRenderFns } from "./CodeBuildingCanvas.vue?vue&type=template&id=27190eb4&"
import script from "./CodeBuildingCanvas.vue?vue&type=script&lang=js&"
export * from "./CodeBuildingCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports